import { DataRole } from '@mode-switch/express';
import { View } from '@mode-switch/model';
import { EnhancedDatasetResult, FlamingoTypes, SwitchAttr, SwitchViewDomain } from '@mode/shared/contract-common';
import { DatasetResourceColumn } from 'libs/shared/contract-common/src/lib/data-view';
import { ModeRole } from 'libs/shared/contract-common/src/lib/flamingo.types';
import { Observable } from 'rxjs';

export abstract class SwitchViewFacade {
  abstract getEnhancedDataseResult(switchViewToken: string): Observable<EnhancedDatasetResult>;
  abstract loadSwitchViewDefinitionRoute(switchViewToken: string): void;
  abstract queryRawDataset(queryToken: string): void;
  abstract loadImportedDatasetSuccess(
    dataView: SwitchViewDomain.DataView,
    shareLink?: string,
    mostRecentReportRunToken?: string
  ): void;
  abstract createSwitchView(
    queryToken: string,
    queryRunToken: string,
    metaColumns: DatasetResourceColumn[],
    attrs: ReadonlyArray<View.Attr<ModeRole>>
  ): View<DataRole>;
  abstract getSwitchView(switchViewToken: string): Observable<SwitchViewDomain.DataView>;
  abstract getDataset(datasetToken: string): Observable<SwitchViewDomain.DataView>;
  abstract getNotebookCellDataset(datasetToken: string, switchViewToken: string): Observable<SwitchViewDomain.DataView>;
  abstract makeView(switchView: View<DataRole>): FlamingoTypes.ModeModel;
  abstract makeAttrs(attrs: SwitchAttr[]): FlamingoTypes.ModeAttr[];
  abstract googleDatasetSyncSwitchViewCompleted(dataView: SwitchViewDomain.DataView): void;
}
